import "../../../index74.css";
import { J as b, K as N, L as D, M as R } from "../../../common-UUpiO33D.js";
import { _ as h } from "../../../cs-piwRuCFZ.js";
import { r as f } from "../../../string-COe5rUcp.js";
import "../../../type-BFTbooL7.js";
import _ from "../../BooleanOutput/index.js";
import T from "../../DateOutput/index.js";
import W from "../../DateRangeOutput/index.js";
import I from "../../NumberOutput/index.js";
import v from "../../ProgressBar/index.js";
import x from "../../ReducedListDisplay/index.js";
import S from "../Cell/index.js";
import d from "../HeaderCell/index.js";
import g from "../TableActions/index.js";
import E from "./ExpandButton/index.js";
import B from "./ExpansionIndicator/index.js";
import H from "./MultiTimelineHeader/index.js";
import M from "./MultiTimelineItem/index.js";
import O from "./TimelineHeader/index.js";
import L from "./TimelineItem/index.js";
const A = "_expansion-indicator-cell-container_uacyr_5", F = "_timeline-cell-container_uacyr_9", V = "_date-column_uacyr_13", u = {
  expansionIndicatorCellContainer: A,
  timelineCellContainer: F,
  dateColumn: V
};
function ee(C, c, l, e) {
  return {
    id: C,
    title: c,
    columnClassName: e == null ? void 0 : e.columnClassName,
    headerCellRenderer: d,
    headerCellRendererClassName: e == null ? void 0 : e.headerCellRendererClassName,
    headerContainerClassName: e == null ? void 0 : e.headerContainerClassName,
    headerCellRendererParams: {
      sortable: e == null ? void 0 : e.sortable,
      infoTitle: e == null ? void 0 : e.headerInfoTitle,
      infoDescription: e == null ? void 0 : e.headerInfoDescription
    },
    cellRendererClassName: e == null ? void 0 : e.cellRendererClassName,
    cellContainerClassName: e == null ? void 0 : e.cellContainerClassName,
    cellRenderer: _,
    cellRendererParams: (m, a) => ({
      value: l(a)
    }),
    valueSelector: l,
    valueComparator: (m, a) => b(l(m), l(a)),
    columnWidth: e == null ? void 0 : e.columnWidth,
    columnStretch: e == null ? void 0 : e.columnStretch,
    columnStyle: e == null ? void 0 : e.columnStyle
  };
}
function le(C, c, l, e) {
  return {
    id: C,
    title: c,
    columnClassName: e == null ? void 0 : e.columnClassName,
    headerCellRenderer: d,
    headerCellRendererClassName: e == null ? void 0 : e.headerCellRendererClassName,
    headerContainerClassName: e == null ? void 0 : e.headerContainerClassName,
    headerCellRendererParams: {
      sortable: e == null ? void 0 : e.sortable,
      infoTitle: e == null ? void 0 : e.headerInfoTitle,
      infoDescription: e == null ? void 0 : e.headerInfoDescription
    },
    cellRendererClassName: e == null ? void 0 : e.cellRendererClassName,
    cellContainerClassName: e == null ? void 0 : e.cellContainerClassName,
    cellRenderer: v,
    cellRendererParams: (m, a) => ({
      value: l(a),
      totalValue: 100,
      showPercentageInTitle: !0
    }),
    valueSelector: l,
    valueComparator: (m, a) => N(l(m), l(a)),
    columnWidth: e == null ? void 0 : e.columnWidth,
    columnStretch: e == null ? void 0 : e.columnStretch,
    columnStyle: e == null ? void 0 : e.columnStyle
  };
}
function re() {
  return {
    id: f(),
    title: "",
    headerCellRenderer: d,
    headerCellRendererParams: {
      sortable: !1
    },
    cellRenderer: S,
    cellRendererParams: () => ({
      value: void 0
    })
  };
}
function ae(C, c, l, e) {
  return {
    id: C,
    title: c,
    columnClassName: e == null ? void 0 : e.columnClassName,
    headerCellRenderer: d,
    headerCellRendererClassName: e == null ? void 0 : e.headerCellRendererClassName,
    headerContainerClassName: e == null ? void 0 : e.headerContainerClassName,
    headerCellRendererParams: {
      sortable: e == null ? void 0 : e.sortable,
      infoTitle: e == null ? void 0 : e.headerInfoTitle,
      infoDescription: e == null ? void 0 : e.headerInfoDescription
    },
    cellRendererClassName: e == null ? void 0 : e.cellRendererClassName,
    cellContainerClassName: e == null ? void 0 : e.cellContainerClassName,
    cellRenderer: S,
    cellRendererParams: (m, a) => ({
      value: l(a) || ((e == null ? void 0 : e.defaultEmptyValue) ?? "--")
    }),
    valueSelector: l,
    valueComparator: (m, a) => D(l(m), l(a)),
    columnWidth: e == null ? void 0 : e.columnWidth,
    columnStretch: e == null ? void 0 : e.columnStretch,
    columnStyle: e == null ? void 0 : e.columnStyle
  };
}
function me(C, c, l, e) {
  return {
    id: C,
    title: c,
    columnClassName: e == null ? void 0 : e.columnClassName,
    headerCellRenderer: d,
    headerCellRendererClassName: h(
      u.numberCellHeader,
      e == null ? void 0 : e.headerCellRendererClassName
    ),
    headerContainerClassName: e == null ? void 0 : e.headerContainerClassName,
    headerCellRendererParams: {
      sortable: e == null ? void 0 : e.sortable,
      infoTitle: e == null ? void 0 : e.headerInfoTitle,
      infoDescription: e == null ? void 0 : e.headerInfoDescription
    },
    cellRendererClassName: h(
      u.numberCell,
      e == null ? void 0 : e.cellRendererClassName
    ),
    cellContainerClassName: e == null ? void 0 : e.cellContainerClassName,
    cellRenderer: I,
    cellRendererParams: (m, a) => ({
      value: l(a),
      suffix: e == null ? void 0 : e.suffix,
      // compact: true,
      maximumFractionDigits: e == null ? void 0 : e.maximumFractionDigits,
      invalidText: "--"
    }),
    valueSelector: l,
    valueComparator: (m, a) => N(l(m), l(a)),
    columnWidth: e == null ? void 0 : e.columnWidth,
    columnStretch: e == null ? void 0 : e.columnStretch,
    columnStyle: e == null ? void 0 : e.columnStyle
  };
}
function Ce(C, c, l, e) {
  return {
    id: C,
    title: c,
    columnClassName: h(e == null ? void 0 : e.columnClassName, u.dateColumn),
    headerCellRenderer: d,
    headerCellRendererClassName: e == null ? void 0 : e.headerCellRendererClassName,
    headerContainerClassName: e == null ? void 0 : e.headerContainerClassName,
    headerCellRendererParams: {
      sortable: e == null ? void 0 : e.sortable,
      infoTitle: e == null ? void 0 : e.headerInfoTitle,
      infoDescription: e == null ? void 0 : e.headerInfoDescription
    },
    cellRendererClassName: e == null ? void 0 : e.cellRendererClassName,
    cellContainerClassName: e == null ? void 0 : e.cellContainerClassName,
    cellRenderer: T,
    cellRendererParams: (m, a) => ({
      value: l(a),
      invalidText: "--"
    }),
    valueSelector: l,
    valueComparator: (m, a) => R(l(m), l(a)),
    columnWidth: e == null ? void 0 : e.columnWidth,
    columnStretch: e == null ? void 0 : e.columnStretch,
    columnStyle: e == null ? void 0 : e.columnStyle
  };
}
function ce(C, c, l, e) {
  return {
    id: C,
    title: c,
    columnClassName: e == null ? void 0 : e.columnClassName,
    headerCellRenderer: d,
    headerCellRendererClassName: e == null ? void 0 : e.headerCellRendererClassName,
    headerContainerClassName: e == null ? void 0 : e.headerContainerClassName,
    headerCellRendererParams: {
      sortable: e == null ? void 0 : e.sortable,
      infoTitle: e == null ? void 0 : e.headerInfoTitle,
      infoDescription: e == null ? void 0 : e.headerInfoDescription
    },
    cellRendererClassName: e == null ? void 0 : e.cellRendererClassName,
    cellRenderer: W,
    cellContainerClassName: e == null ? void 0 : e.cellContainerClassName,
    cellRendererParams: (m, a) => ({
      ...l(a)
    }),
    valueSelector: (m) => l(m).startDate,
    valueComparator: (m, a) => {
      const { startDate: y } = l(m), { startDate: P } = l(a);
      return R(y, P);
    },
    columnWidth: e == null ? void 0 : e.columnWidth,
    columnStretch: e == null ? void 0 : e.columnStretch,
    columnStyle: e == null ? void 0 : e.columnStyle
  };
}
function de(C, c, l, e) {
  return {
    id: C,
    title: c,
    columnClassName: e == null ? void 0 : e.columnClassName,
    headerCellRenderer: d,
    headerCellRendererClassName: e == null ? void 0 : e.headerCellRendererClassName,
    headerContainerClassName: e == null ? void 0 : e.headerContainerClassName,
    headerCellRendererParams: {
      sortable: !1
    },
    cellRendererClassName: e == null ? void 0 : e.cellRendererClassName,
    cellContainerClassName: e == null ? void 0 : e.cellContainerClassName,
    cellRenderer: E,
    cellRendererParams: (m, a) => ({
      ...l(a),
      row: a
    }),
    columnWidth: e == null ? void 0 : e.columnWidth,
    columnStretch: e == null ? void 0 : e.columnStretch,
    columnStyle: e == null ? void 0 : e.columnStyle
  };
}
function ue(C) {
  return {
    id: f(),
    title: "",
    headerCellRenderer: d,
    headerCellRendererParams: {
      sortable: !1
    },
    cellRenderer: B,
    cellRendererParams: (l, e, r, m) => {
      let a = "mid";
      return m.length === 1 ? a = "single" : r === 0 ? a = "start" : r === m.length - 1 && (a = "end"), {
        isExpanded: C,
        variant: a
      };
    },
    cellContainerClassName: u.expansionIndicatorCellContainer,
    cellRendererClassName: u.expansionIndicatorCell
  };
}
function he(C, c, l, e, r) {
  return {
    id: C,
    title: c,
    headerCellRenderer: d,
    headerCellRendererParams: {
      sortable: r == null ? void 0 : r.sortable,
      infoTitle: r == null ? void 0 : r.headerInfoTitle,
      infoDescription: r == null ? void 0 : r.headerInfoDescription
    },
    cellRenderer: l,
    cellRendererParams: e,
    headerContainerClassName: r == null ? void 0 : r.headerContainerClassName,
    cellRendererClassName: r == null ? void 0 : r.cellRendererClassName,
    columnClassName: r == null ? void 0 : r.columnClassName,
    headerCellRendererClassName: r == null ? void 0 : r.headerCellRendererClassName,
    cellContainerClassName: r == null ? void 0 : r.cellContainerClassName,
    columnWidth: r == null ? void 0 : r.columnWidth,
    columnStretch: r == null ? void 0 : r.columnStretch,
    columnStyle: r == null ? void 0 : r.columnStyle
  };
}
function Ne(C, c, l, e) {
  return {
    id: C,
    title: "",
    headerCellRenderer: O,
    headerCellRendererParams: {
      dateRange: c,
      sortable: e == null ? void 0 : e.sortable
    },
    cellRenderer: L,
    cellRendererParams: (m, a) => ({
      dateRange: c,
      ...l(a)
    }),
    headerContainerClassName: e == null ? void 0 : e.headerContainerClassName,
    cellRendererClassName: e == null ? void 0 : e.cellRendererClassName,
    columnClassName: e == null ? void 0 : e.columnClassName,
    headerCellRendererClassName: e == null ? void 0 : e.headerCellRendererClassName,
    cellContainerClassName: h(
      e == null ? void 0 : e.cellContainerClassName,
      u.timelineCellContainer
    ),
    columnWidth: e == null ? void 0 : e.columnWidth,
    columnStretch: e == null ? void 0 : e.columnStretch,
    columnStyle: e == null ? void 0 : e.columnStyle
  };
}
function Re(C, c, l) {
  return {
    id: C,
    title: "",
    headerCellRenderer: d,
    headerCellRendererParams: {
      sortable: !1
    },
    headerContainerClassName: l == null ? void 0 : l.headerContainerClassName,
    cellRenderer: g,
    cellRendererParams: (r, m) => ({
      ...c(m)
    }),
    cellRendererClassName: l == null ? void 0 : l.cellRendererClassName,
    columnClassName: l == null ? void 0 : l.columnClassName,
    headerCellRendererClassName: l == null ? void 0 : l.headerCellRendererClassName,
    cellContainerClassName: l == null ? void 0 : l.cellContainerClassName,
    columnWidth: l == null ? void 0 : l.columnWidth,
    columnStretch: l == null ? void 0 : l.columnStretch,
    columnStyle: l == null ? void 0 : l.columnStyle
  };
}
function fe(C, c, l, e) {
  return {
    id: C,
    title: "",
    headerCellRenderer: H,
    headerCellRendererParams: {
      dateRange: c,
      sortable: e == null ? void 0 : e.sortable
    },
    cellRenderer: M,
    cellRendererParams: (m, a) => ({
      dateRange: c,
      ...l(a)
    }),
    headerContainerClassName: e == null ? void 0 : e.headerContainerClassName,
    cellRendererClassName: e == null ? void 0 : e.cellRendererClassName,
    columnClassName: e == null ? void 0 : e.columnClassName,
    headerCellRendererClassName: e == null ? void 0 : e.headerCellRendererClassName,
    cellContainerClassName: h(
      e == null ? void 0 : e.cellContainerClassName,
      u.timelineCellContainer
    ),
    columnWidth: e == null ? void 0 : e.columnWidth,
    columnStretch: e == null ? void 0 : e.columnStretch,
    columnStyle: e == null ? void 0 : e.columnStyle
  };
}
function Se(C, c, l, e) {
  return {
    id: C,
    title: c,
    headerCellRenderer: d,
    headerCellRendererParams: {
      sortable: !1
    },
    headerContainerClassName: e == null ? void 0 : e.headerContainerClassName,
    cellRenderer: x,
    cellRendererParams: (m, a) => ({
      ...l(a)
    }),
    cellRendererClassName: e == null ? void 0 : e.cellRendererClassName,
    columnClassName: e == null ? void 0 : e.columnClassName,
    headerCellRendererClassName: e == null ? void 0 : e.headerCellRendererClassName,
    cellContainerClassName: e == null ? void 0 : e.cellContainerClassName,
    columnWidth: e == null ? void 0 : e.columnWidth,
    columnStretch: e == null ? void 0 : e.columnStretch,
    columnStyle: e == null ? void 0 : e.columnStyle
  };
}
export {
  Re as createActionColumn,
  ee as createBooleanColumn,
  Ce as createDateColumn,
  ce as createDateRangeColumn,
  he as createElementColumn,
  re as createEmptyColumn,
  de as createExpandColumn,
  ue as createExpansionIndicatorColumn,
  Se as createListDisplayColumn,
  fe as createMultiTimelineColumn,
  me as createNumberColumn,
  le as createProgressColumn,
  ae as createStringColumn,
  Ne as createTimelineColumn
};
